import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from '../reducers';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import { api } from 'services/api/baseBackendAPI';
import logRocketListenerMiddleware from '../listeners/logRocketSessionMiddleware';
import LogRocket from 'logrocket';

const persistConfig = {
  timeout: 5,
  key: 'root',
  version: 1,
  storage: localStorage,
  debug: true,
  // api contains results of api calls using rtk query. avoid persisting it so refreshes clear the api results.
  // aiChat.currentChatTopic should not be persisted as it's session-specific
  blacklist: ['api', 'aiChat'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const configureStoreDev = (preloadedState = {}) =>
  configureStore({
    reducer: persistedReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      })
        .concat(logRocketListenerMiddleware)
        .concat(api.middleware)
        .concat(LogRocket.reduxMiddleware()),
    devTools: true,
  });
